require('./sideHeaders.less');

var Marionette = require('marionette'),
    $ = require('jquery');

require('extendJQuery'); // ( unselectable )

module.exports = Marionette.ItemView.extend({

    events:  {
        'click .sidePanelTglBtn': 'togglePanelBtnClicked'
    },

    toggleHeaderViewModeState: $.noop,

    /* switch panels or close all if click on the open one) */
    togglePanelBtnClicked: function(e) {

        this.options.lChannel.trigger('layout:sideHeaderTabClick', this.options.model, $(e.currentTarget).data('panel'));

    },

    //TODO: call from controller -- at the region level
    toggleActivePane: function(sideModel, subPane) {

        var allSubPaneClasses = sideModel.get('subPanes').join(' '),
            $parentEl= this._parent.$el;

        $parentEl.removeClass(allSubPaneClasses);

       (subPane !== null) && $parentEl.addClass(subPane); //(only if open)
    },

    onShow: function() {
        this.$el.unselectable();
    },

    // TODO: make part of destroy unselectable... need to clear from the jqCache
    onBeforeDestroy: function() {

        this.$el.find('*').each(function() {
           $(this).remove();
        });

    },
    destroy: function() {

        Marionette.ItemView.prototype.destroy.apply(this, arguments);
        /* necessary to remove detached node refs from jq cache */
        this.el = null;
        this.$el = null;

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/sidePanelHeader.js
 ** module id = 732
 ** module chunks = 0
 **/